<div class="rewardsContainer">
  <div class="gridContainer">
    <app-item-information-rewards
      *ngFor="let item of items"
      [title]="item.title"
      [subtitle]="item.subtitle"
      [icon]="item.icon"
      [btnName]="item.btnName"
      [showButton]="item.showButton"
      [backgroundImage]="item.backgroundImage"
      (click)="handleItemClick(item)"
      (onClick)="handleItemClick(item)">
    </app-item-information-rewards>
  </div>
</div>
